import React from "react";

/*
 * The active filters, as removable chips in the header.
 *
 * Filters COMPOSE: a stage and a source are two independent narrowings of the
 * same cohort, so each gets its own chip and each is removable on its own. One
 * chip reading "LinkedIn, Opportunities" would make the pair look like a single
 * choice you can only take or leave.
 *
 * The chip is the only thing on the page that says a filter is on, which is why
 * it sits in the header next to the scope rather than beside whatever was
 * clicked: a reader who scrolls back to the top has to be able to see that the
 * numbers below are narrowed. The funnel caption repeats it, deliberately.
 */

const STAGE_LABELS = {
  leads: "Leads stage",
  calls: "Intro calls stage",
  opps: "Opportunities stage",
  won: "New customers stage",
};

const SOURCE_LABELS = {
  linkedin: "LinkedIn",
  referral: "Referral",
  organic: "Organic",
  unattributed: "Unattributed",
};

function Chip({ label, onRemove }) {
  return (
    <span className="crm-fchip">
      <span>{label}</span>
      <button type="button" aria-label={`Remove filter ${label}`} onClick={onRemove}>
        ✕
      </button>
    </span>
  );
}

export default function ReportsFilters({ stage, source, onClearStage, onClearSource }) {
  if (!stage && !source) return null;
  return (
    <>
      {source && <Chip label={SOURCE_LABELS[source] || source} onRemove={onClearSource} />}
      {stage && <Chip label={STAGE_LABELS[stage] || stage} onRemove={onClearStage} />}
    </>
  );
}
